export const isInsideCommunityCondition = {
  outside_community: { $ne: true }
}
